// extracted by mini-css-extract-plugin
export default {"duplex":"SignUpWorkflow_duplex__PY-AD","text":"SignUpWorkflow_text__+tbOj","container":"SignUpWorkflow_container__zvx-m","header":"SignUpWorkflow_header__mgK8G"};